(function () {
  'use strict';

  var roots = Array.prototype.slice.call(document.querySelectorAll('.hc-easter-game'));
  if (!roots.length) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[id*="hc-easter-game--"]'));
  }
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.__hcEasterMounted) return;
    root.__hcEasterMounted = true;

    var elements = {
      grid: root.querySelector('[data-hc-eg-grid]'),
      popup: root.querySelector('[data-hc-eg-popup]'),
      popupPrize: root.querySelector('[data-hc-eg-popup-prize]'),
      popupCodeWrap: root.querySelector('[data-hc-eg-popup-code-wrap]'),
      popupCode: root.querySelector('[data-hc-eg-popup-code]'),
      popupCopy: root.querySelector('[data-hc-eg-popup-copy]'),
      turnText: root.querySelector('[data-hc-eg-turn-text]'),
      barTurn: root.querySelector('[data-hc-eg-bar-turn]'),
      voucherWrap: root.querySelector('[data-hc-eg-voucher]'),
      voucherList: root.querySelector('[data-hc-eg-voucher-list]'),
      summary: root.querySelector('[data-hc-eg-summary]'),
      bestLine: root.querySelector('[data-hc-eg-best-line]'),
      useNow: root.querySelector('[data-hc-eg-use-now]'),
      freeBagWrap: root.querySelector('[data-hc-eg-free-bag]'),
      freeBagGrid: root.querySelector('[data-hc-eg-free-bag-grid]'),
      freeBagViewport: root.querySelector('[data-hc-eg-bag-viewport]'),
      freeBagPrev: root.querySelector('[data-hc-eg-bag-prev]'),
      freeBagNext: root.querySelector('[data-hc-eg-bag-next]'),
      freeBagDots: root.querySelector('[data-hc-eg-bag-dots]'),
      claimBtn: root.querySelector('[data-hc-eg-claim]'),
      productsWrap: root.querySelector('[data-hc-eg-products]'),
      productsGrid: root.querySelector('[data-hc-eg-products-grid]'),
      claimProductBtn: root.querySelector('[data-hc-eg-claim-product]'),
      productsViewport: root.querySelector('[data-hc-eg-products-viewport]'),
      productsPrev: root.querySelector('[data-hc-eg-products-prev]'),
      productsNext: root.querySelector('[data-hc-eg-products-next]'),
      productsDots: root.querySelector('[data-hc-eg-products-dots]'),
      bagSource: root.querySelector('[data-hc-eg-bag-source]'),
      chatList: root.querySelector('[data-hc-eg-chat-list]'),
      viewers: root.querySelector('[data-hc-eg-viewers]'
      ),
      productsTabs: root.querySelector('[data-hc-eg-products-tabs]')
    };

    if (!elements.grid) return;

    var config = {
      collectionUrl: root.getAttribute('data-collection-url') || '/collections/all',
      collectionHandle: root.getAttribute('data-collection-handle') || '',
      useNowTarget: root.getAttribute('data-use-now-target') || '',
      code50: root.getAttribute('data-code-50') || 'EASTER50',
      code45: root.getAttribute('data-code-45') || 'EASTER45',
      code70: root.getAttribute('data-code-70') || 'EASTER70',
      code25: root.getAttribute('data-code-25') || 'EASTER25',
      code20: root.getAttribute('data-code-20') || 'EASTER20',
      code15: root.getAttribute('data-code-15') || 'EASTER15',
      code10: root.getAttribute('data-code-10') || 'EASTER10',
      codeFree: root.getAttribute('data-code-free') || 'EASTERFREE',
      eggIntact: root.getAttribute('data-egg-intact') || '',
      eggCracked: root.getAttribute('data-egg-cracked') || '',
      textStartsLabel: root.getAttribute('data-text-starts-label') || 'Game Starts In',
      textStartsMsg: root.getAttribute('data-text-starts-msg') || 'Get ready to crack some eggs and win amazing deals!',
      textEndedLabel: root.getAttribute('data-text-ended-label') || 'Campaign Has Ended',
      textEndedMsg: root.getAttribute('data-text-ended-msg') || 'Thanks for playing! Stay tuned for our next event.',
      textVoucherClaim: root.getAttribute('data-text-voucher-claim') || 'Claim',
      textVoucherApplied: root.getAttribute('data-text-voucher-applied') || '✓ Applied!',
      textClaimBag: root.getAttribute('data-text-claim-bag') || 'CLAIM BAG',
      textClaimProduct: root.getAttribute('data-text-claim-product') || 'CLAIM BAG',
      textProductsTitle: root.getAttribute('data-text-products-title') || 'Shop with Your Discount!'
    };

    function getEggImage(index, state) {
      var n = index + 1;
      var perEgg = root.getAttribute('data-egg-' + state + '-' + n) || '';
      return perEgg || config['egg' + (state === 'intact' ? 'Intact' : 'Cracked')] || '';
    }

    /* ── Campaign timer ── */
    var timerEl = root.querySelector('[data-hc-eg-timer]');
    var gameBody = root.querySelector('[data-hc-eg-game-body]');
    var activeCountdown = root.querySelector('[data-hc-eg-active-countdown]');
    var endD = root.querySelector('[data-hc-eg-end-d]');
    var endH = root.querySelector('[data-hc-eg-end-h]');
    var endM = root.querySelector('[data-hc-eg-end-m]');
    var endS = root.querySelector('[data-hc-eg-end-s]');

    function parseET(str) {
      if (!str) return null;
      var parts = str.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
      if (!parts) return null;
      var utcNow = new Date();
      var etNow = new Date(utcNow.toLocaleString('en-US', { timeZone: 'America/New_York' }));
      var offsetMs = utcNow.getTime() - etNow.getTime();
      var target = new Date(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], 0);
      return new Date(target.getTime() + offsetMs);
    }

    var campaignStart = parseET(root.getAttribute('data-start'));
    var campaignEnd = parseET(root.getAttribute('data-end'));

    function pad2(n) { return n < 10 ? '0' + n : String(n); }

    function formatCountdown(ms) {
      if (ms <= 0) return { days: '00', hours: '00', mins: '00', secs: '00' };
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      return { days: pad2(d), hours: pad2(h), mins: pad2(m), secs: pad2(s) };
    }

    function getCampaignState() {
      var now = Date.now();
      if (campaignStart && now < campaignStart.getTime()) return 'NOT_STARTED';
      if (campaignEnd && now > campaignEnd.getTime()) return 'ENDED';
      return 'ACTIVE';
    }

    function renderTimerState(campaignState) {
      var label = timerEl.querySelector('[data-hc-eg-timer-label]');
      var msg = timerEl.querySelector('[data-hc-eg-timer-msg]');

      if (campaignState === 'NOT_STARTED') {
        timerEl.hidden = false;
        timerEl.classList.remove('hc-easter-game__timer--ended');
        if (gameBody) gameBody.hidden = true;
        label.textContent = config.textStartsLabel;
        msg.textContent = config.textStartsMsg;
      } else if (campaignState === 'ENDED') {
        timerEl.hidden = false;
        timerEl.classList.add('hc-easter-game__timer--ended');
        if (gameBody) gameBody.hidden = true;
        label.textContent = config.textEndedLabel;
        msg.textContent = config.textEndedMsg;
      } else {
        timerEl.hidden = true;
        if (gameBody) gameBody.hidden = false;
        if (activeCountdown && campaignEnd) activeCountdown.hidden = false;
      }
    }

    function tickTimer() {
      var campaignState = getCampaignState();
      var now = Date.now();
      var diff;
      var c;
      var daysEl;
      var hoursEl;
      var minsEl;
      var secsEl;
      var endDiff;
      var ec;

      if (campaignState === 'NOT_STARTED' && campaignStart) {
        diff = campaignStart.getTime() - now;
        c = formatCountdown(diff);
        daysEl = timerEl.querySelector('[data-hc-eg-days]');
        hoursEl = timerEl.querySelector('[data-hc-eg-hours]');
        minsEl = timerEl.querySelector('[data-hc-eg-mins]');
        secsEl = timerEl.querySelector('[data-hc-eg-secs]');
        if (daysEl) daysEl.textContent = c.days;
        if (hoursEl) hoursEl.textContent = c.hours;
        if (minsEl) minsEl.textContent = c.mins;
        if (secsEl) secsEl.textContent = c.secs;

        if (diff <= 0) {
          renderTimerState('ACTIVE');
          return;
        }
      }

      if (campaignState === 'ACTIVE' && campaignEnd) {
        endDiff = campaignEnd.getTime() - now;
        if (endDiff <= 0) {
          renderTimerState('ENDED');
          return;
        }
        ec = formatCountdown(endDiff);
        if (endD) endD.textContent = ec.days;
        if (endH) endH.textContent = ec.hours;
        if (endM) endM.textContent = ec.mins;
        if (endS) endS.textContent = ec.secs;
      }
    }

    var hasTimer = campaignStart || campaignEnd;
    var initialState;
    if (hasTimer) {
      initialState = getCampaignState();
      renderTimerState(initialState);
      setInterval(tickTimer, 1000);
      tickTimer();
      if (initialState !== 'ACTIVE') {
        return;
      }
    }

    var pool = {
      fifty: { key: 'fifty', label: '50% OFF', code: config.code50, score: 500, confetti: true },
      fortyFive: { key: 'forty_five', label: '45% OFF', code: config.code45, score: 450, confetti: true },
      seventy: { key: 'seventy', label: '70% OFF', code: config.code70, score: 700, confetti: true },
      twentyFive: { key: 'twenty_five', label: '25% OFF', code: config.code25, score: 250 },
      twenty: { key: 'twenty', label: '20% OFF', code: config.code20, score: 200 },
      fifteen: { key: 'fifteen', label: '15% OFF', code: config.code15, score: 150 },
      ten: { key: 'ten', label: '10% OFF', code: config.code10, score: 100 },
      consolation: { key: 'consolation', label: 'Oops! Empty Egg', code: '', score: 0 },
      freeBag: { key: 'free_bag', label: 'Free Bag', code: config.codeFree, score: 1000, confetti: true, needsBag: true }
    };

    var state = {
      turnsTotal: 3,
      turn: 0,
      locked: false,
      turnPrizes: [],
      wins: [],
      freeBagWon: false,
      selectedBagVariantId: '',
      chatTimer: null,
      viewers: 1248,
      bestCode: ''
    };

    var productsCache = [];
    var selectedProductVariantId = null;
    var tabsProductsCache = {};

    function updateTurnBoxes() {
      if (elements.turnText) {
        elements.turnText.textContent = 'turn ' + Math.min(state.turn + 1, state.turnsTotal) + '/' + state.turnsTotal;
      }
    }

    function fetchCollectionProducts() {
      if (!config.collectionHandle) return;
      var url = '/collections/' + config.collectionHandle + '/products.json?limit=250';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          productsCache = (data.products || []).filter(function (p) {
            return p.variants && p.variants.length && p.variants[0].available;
          }).map(function (p) {
            var v = p.variants[0];
            return {
              id: p.id,
              variantId: v.id,
              title: p.title,
              price: Math.round(parseFloat(v.price) * 100),
              img: p.images && p.images.length ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_400x400$1$2') : '',
              handle: p.handle
            };
          });
        })
        .catch(function () {});
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function fmtPrice(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    /* ── Products Embla carousel ── */
    var productsEmbla = null;
    var productsDotNodes = [];

    function initProductsCarousel() {
      if (productsEmbla) { productsEmbla.destroy(); productsEmbla = null; }
      if (typeof EmblaCarousel === 'undefined' || !elements.productsViewport) {
        /* Fallback: native horizontal scroll when Embla unavailable */
        if (elements.productsViewport) {
          elements.productsViewport.style.overflowX = 'auto';
          elements.productsViewport.style.webkitOverflowScrolling = 'touch';
        }
        return;
      }

      productsEmbla = EmblaCarousel(elements.productsViewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      productsEmbla.on('select', function () { updateProductsDots(); updateProductsArrows(); });
      productsEmbla.on('reInit', function () { buildProductsDots(); updateProductsArrows(); });

      buildProductsDots();
      updateProductsArrows();

      if (elements.productsPrev && !elements.productsPrev.__hcBound) {
        elements.productsPrev.__hcBound = true;
        elements.productsPrev.hidden = false;
        elements.productsPrev.addEventListener('click', function () { if (productsEmbla) productsEmbla.scrollPrev(); });
      }
      if (elements.productsNext && !elements.productsNext.__hcBound) {
        elements.productsNext.__hcBound = true;
        elements.productsNext.hidden = false;
        elements.productsNext.addEventListener('click', function () { if (productsEmbla) productsEmbla.scrollNext(); });
      }
    }

    function buildProductsDots() {
      if (!productsEmbla || !elements.productsDots) return;
      var snaps = productsEmbla.scrollSnapList();
      elements.productsDots.innerHTML = '';
      productsDotNodes = [];
      if (snaps.length <= 1) return;
      snaps.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'hc-easter-game__products-dot';
        dot.setAttribute('aria-label', 'Go to group ' + (i + 1));
        dot.addEventListener('click', function () { productsEmbla.scrollTo(i); });
        elements.productsDots.appendChild(dot);
        productsDotNodes.push(dot);
      });
      updateProductsDots();
    }

    function updateProductsDots() {
      if (!productsEmbla || !productsDotNodes.length) return;
      var selected = productsEmbla.selectedScrollSnap();
      productsDotNodes.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === selected);
      });
    }

    function updateProductsArrows() {
      if (!productsEmbla) return;
      if (elements.productsPrev) elements.productsPrev.disabled = !productsEmbla.canScrollPrev();
      if (elements.productsNext) elements.productsNext.disabled = !productsEmbla.canScrollNext();
    }

    /* ── Product tabs helpers ── */

    function getConfiguredTabs() {
      var tabs = [];
      for (var i = 1; i <= 5; i++) {
        var h = (root.getAttribute('data-tab-' + i + '-handle') || '').trim();
        var l = (root.getAttribute('data-tab-' + i + '-label') || h).trim();
        if (h) tabs.push({ handle: h, label: l });
      }
      return tabs;
    }

    function fetchTabProducts(handle, callback) {
      if (tabsProductsCache[handle]) { callback(tabsProductsCache[handle]); return; }
      fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          tabsProductsCache[handle] = (data.products || [])
            .filter(function (p) { return p.variants && p.variants.length && p.variants[0].available; })
            .map(function (p) {
              var v = p.variants[0];
              return {
                id: p.id,
                variantId: v.id,
                title: p.title,
                price: Math.round(parseFloat(v.price) * 100),
                img: p.images && p.images.length ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_400x400$1$2') : '',
                handle: p.handle
              };
            });
          callback(tabsProductsCache[handle]);
        })
        .catch(function () { callback([]); });
    }

    function renderProductsGrid(products, discountPct) {
      var grid = elements.productsGrid;
      if (!grid) return;

      selectedProductVariantId = null;
      if (elements.claimProductBtn) {
        elements.claimProductBtn.disabled = true;
        elements.claimProductBtn.textContent = config.textClaimProduct;
      }

      var html = '';
      products.forEach(function (p) {
        var discounted = Math.round(p.price * (1 - discountPct / 100));
        html += '<div class="hc-easter-game__product" data-variant-id="' + p.variantId + '" tabindex="0">';
        html += '<div class="hc-easter-game__product-badge">' + discountPct + '% OFF</div>';
        html += '<img class="hc-easter-game__product-img" src="' + escapeHtml(p.img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
        html += '<div class="hc-easter-game__product-info">';
        html += '<div class="hc-easter-game__product-name">' + escapeHtml(p.title) + '</div>';
        html += '<div class="hc-easter-game__product-prices">';
        html += '<span class="hc-easter-game__product-old">' + fmtPrice(p.price) + '</span> ';
        html += '<span class="hc-easter-game__product-new">' + fmtPrice(discounted) + '</span>';
        html += '</div></div></div>';
      });
      grid.innerHTML = html;
      initProductsCarousel();

      Array.prototype.slice.call(grid.querySelectorAll('.hc-easter-game__product')).forEach(function (card) {
        card.addEventListener('click', function () {
          Array.prototype.slice.call(grid.querySelectorAll('.hc-easter-game__product')).forEach(function (c) {
            c.classList.remove('is-selected');
          });
          card.classList.add('is-selected');
          selectedProductVariantId = card.getAttribute('data-variant-id');
          if (elements.claimProductBtn) {
            elements.claimProductBtn.disabled = false;
            elements.claimProductBtn.textContent = config.textClaimProduct;
          }
        });
        card.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); card.click(); }
        });
      });
    }

    function buildProductsTabBar(tabs, discountPct) {
      var tabBar = elements.productsTabs;
      if (!tabBar) return;
      tabBar.innerHTML = '';

      tabs.forEach(function (tab, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hc-easter-game__products-tab' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', String(idx === 0));
        btn.textContent = tab.label;
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-active')) return;
          Array.prototype.slice.call(tabBar.querySelectorAll('.hc-easter-game__products-tab')).forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
            b.disabled = false;
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          btn.disabled = true;
          fetchTabProducts(tab.handle, function (products) {
            btn.disabled = false;
            renderProductsGrid(products, discountPct);
          });
        });
        tabBar.appendChild(btn);
      });

      fetchTabProducts(tabs[0].handle, function (products) {
        renderProductsGrid(products, discountPct);
      });
    }

    function showCollectionProducts(discountCode, discountPct) {
      var grid = elements.productsGrid;
      var wrap = elements.productsWrap;
      var claimProductBtn = elements.claimProductBtn;
      if (!grid || !wrap || !claimProductBtn) return;

      var tabs = getConfiguredTabs();
      if (!tabs.length && !productsCache.length) return;

      var title = wrap.querySelector('.hc-easter-game__products-title');
      if (title) title.textContent = config.textProductsTitle.replace('{discount}', discountPct);

      var codeDisplay = wrap.querySelector('[data-hc-eg-discount-code]');
      if (codeDisplay && discountCode) {
        var codeText = codeDisplay.querySelector('[data-hc-eg-discount-text]');
        var copyBtn = codeDisplay.querySelector('[data-hc-eg-copy-code]');
        if (codeText) codeText.textContent = 'Your discount code is: ' + discountCode;
        codeDisplay.hidden = false;
        if (copyBtn) copyBtn.onclick = function () { copyText(discountCode, copyBtn); };
      }

      var bagCodeDisplay = elements.freeBagWrap ? elements.freeBagWrap.querySelector('[data-hc-eg-bag-discount-code]') : null;
      if (bagCodeDisplay && discountCode) {
        var bagCodeText = bagCodeDisplay.querySelector('[data-hc-eg-bag-discount-text]');
        var bagCopyBtn = bagCodeDisplay.querySelector('[data-hc-eg-bag-copy-code]');
        if (bagCodeText) bagCodeText.textContent = 'Your discount code is: ' + discountCode;
        bagCodeDisplay.hidden = false;
        if (bagCopyBtn) bagCopyBtn.onclick = function () { copyText(discountCode, bagCopyBtn); };
      }

      wrap.hidden = false;
      claimProductBtn.disabled = true;
      claimProductBtn.textContent = config.textClaimProduct;
      claimProductBtn.onclick = function () {
        if (!selectedProductVariantId) return;
        claimProductBtn.disabled = true;
        claimProductBtn.textContent = 'Adding to cart...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(selectedProductVariantId), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout';
          })
          .catch(function () {
            claimProductBtn.textContent = 'Error — try again';
            claimProductBtn.disabled = false;
          });
      };

      if (tabs.length > 0) {
        buildProductsTabBar(tabs, discountPct);
      } else {
        renderProductsGrid(productsCache, discountPct);
      }

      window.setTimeout(function () {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    function clonePrize(prize) {
      return {
        key: prize.key,
        label: prize.label,
        code: prize.code,
        score: prize.score || 0,
        confetti: Boolean(prize.confetti),
        needsBag: Boolean(prize.needsBag)
      };
    }

    function randInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function randomOf(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function shuffle(arr) {
      var a = arr.slice();
      var i;
      var j;
      var t;
      for (i = a.length - 1; i > 0; i -= 1) {
        j = Math.floor(Math.random() * (i + 1));
        t = a[i];
        a[i] = a[j];
        a[j] = t;
      }
      return a;
    }

    function weightedRandom() {
      var weighted = [
        { prize: pool.seventy, w: 2 },
        { prize: pool.twentyFive, w: 12 },
        { prize: pool.twenty, w: 20 },
        { prize: pool.fifteen, w: 25 },
        { prize: pool.ten, w: 40 }
      ];
      var total = weighted.reduce(function (sum, item) { return sum + item.w; }, 0);
      var r = Math.random() * total;
      var cumulative = 0;
      var i;
      for (i = 0; i < weighted.length; i += 1) {
        cumulative += weighted[i].w;
        if (r <= cumulative) return clonePrize(weighted[i].prize);
      }
      return clonePrize(pool.ten);
    }

    var debugAttr = root.getAttribute('data-debug') || '';
    var debugParam = (new URLSearchParams(window.location.search)).get('debug') || '';
    var debugMode = (debugAttr !== 'off' && debugAttr) ? debugAttr : debugParam;

    function computeTurnPrizes() {
      if (debugMode === 'freebag') {
        return [clonePrize(pool.freeBag), clonePrize(pool.fifty), clonePrize(pool.consolation)];
      }
      if (debugMode === 'jackpot') {
        return [clonePrize(pool.seventy), clonePrize(pool.fifty), clonePrize(pool.freeBag)];
      }
      var slotAB = Math.random() < 0.5 ? clonePrize(pool.fifty) : clonePrize(pool.fortyFive);
      var slotC = clonePrize(pool.consolation);
      var slotD = weightedRandom();
      return shuffle([slotAB, slotC, slotD]);
    }

    function buildEgg(index) {
      var intactUrl = getEggImage(index, 'intact');
      var icon = intactUrl
        ? '<img class="hc-easter-game__egg-img" src="' + intactUrl + '" alt="Easter egg" width="120" height="144" loading="lazy" draggable="false">'
        : '<span class="hc-easter-game__egg-icon" aria-hidden="true"></span>';
      return (
        '<button type="button" class="hc-easter-game__egg" data-egg-index="' + index + '">' +
          icon +
          '<span class="hc-easter-game__egg-label" data-egg-label>tap to crack</span>' +
        '</button>'
      );
    }

    function renderGrid() {
      var html = '';
      var i;
      for (i = 0; i < 9; i += 1) {
        html += buildEgg(i);
      }
      elements.grid.innerHTML = html;
      state.locked = false;
      if (elements.popup) elements.popup.hidden = true;
      if (!state.freeBagWon) elements.freeBagWrap.hidden = true;
      updateTurnBoxes();
      if (elements.barTurn) elements.barTurn.textContent = 'Turn 1/3';
    }

    function randomDecoyPrizes(count) {
      var decoyPool = [
        pool.fifty,
        pool.fortyFive,
        pool.seventy,
        pool.twentyFive,
        pool.twenty,
        pool.fifteen,
        pool.ten,
        pool.consolation,
        pool.freeBag
      ];
      var out = [];
      var i;
      for (i = 0; i < count; i += 1) {
        out.push(clonePrize(randomOf(decoyPool)));
      }
      return out;
    }

    function setEggPrize(egg, prize, isPicked) {
      var label = egg.querySelector('[data-egg-label]');
      if (!label) return;
      label.innerHTML = prize.label;
    }

    function runConfettiBurst() {}

    function updatePopup() {}

    function findBestPrize() {
      if (!state.wins.length) return null;
      return state.wins.reduce(function (best, row) {
        if (!best) return row.prize;
        return row.prize.score > best.score ? row.prize : best;
      }, null);
    }

    function applyDiscountAndScroll(code) {
      var target = config.useNowTarget ? config.useNowTarget.replace(/^#/, '') : '';
      var el = target ? document.getElementById(target) : null;

      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
        .then(function () {
          return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code })
          });
        })
        .then(function () {
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () {
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    function voucherRow(win) {
      var hasCode = Boolean(win.prize.code);
      var action = hasCode
        ? '<button type="button" class="hc-easter-game__btn hc-easter-game__btn--copy" data-copy-code="' + win.prize.code + '">Claim</button>'
        : '';
      return (
        '<article class="hc-easter-game__voucher-item">' +
          '<p class="hc-easter-game__voucher-line">🥚 Turn ' + win.turn + ': ' + win.prize.label + ' <strong>✓</strong></p>' +
          action +
        '</article>'
      );
    }

    function updateVoucherBar() {
      if (!state.wins.length) {
        elements.voucherWrap.hidden = true;
        return;
      }

      elements.voucherWrap.hidden = false;
      elements.voucherList.innerHTML = state.wins.map(voucherRow).join('');

      var best = findBestPrize();
      if (best) state.bestCode = best.code || '';
    }

    function selectBagCard(card) {
      var allCards = Array.prototype.slice.call(elements.freeBagGrid.querySelectorAll('.hc-easter-game__bag-card'));
      allCards.forEach(function (n) { n.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      var variantSelect = card.querySelector('[data-bag-variant-select]');
      state.selectedBagVariantId = variantSelect
        ? variantSelect.value
        : (card.getAttribute('data-variant-id') || '');
      elements.claimBtn.disabled = !state.selectedBagVariantId;
      elements.claimBtn.textContent = state.selectedBagVariantId ? config.textClaimBag : config.textClaimBag;
    }

    var bagEmbla = null;
    var bagDotNodes = [];

    function hydrateFreeBags() {
      if (!elements.bagSource || !elements.freeBagGrid) return;
      elements.freeBagGrid.innerHTML = elements.bagSource.innerHTML;

      var cards = Array.prototype.slice.call(elements.freeBagGrid.querySelectorAll('.hc-easter-game__bag-card'));

      cards.forEach(function (card) {
        var variants = [];
        try { variants = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch (e) {}
        var firstVariant = variants.length ? variants[0] : null;

        var variantSelect = card.querySelector('[data-bag-variant-select]');
        if (variantSelect) variantSelect.style.display = 'none';

        if (!firstVariant || !firstVariant.available) {
          card.classList.add('is-unavailable');
          card.setAttribute('data-variant-id', '');
          var soldOut = document.createElement('span');
          soldOut.className = 'hc-easter-game__bag-sold-out';
          soldOut.textContent = 'Sold Out';
          card.appendChild(soldOut);
          return;
        }

        card.setAttribute('data-variant-id', String(firstVariant.id));

        card.addEventListener('click', function () {
          selectBagCard(card);
          if (bagEmbla) {
            var idx = Array.prototype.indexOf.call(elements.freeBagGrid.children, card);
            if (idx >= 0) bagEmbla.scrollTo(idx);
          }
        });
      });

      var firstAvailable = null;
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].classList.contains('is-unavailable')) {
          firstAvailable = cards[i];
          break;
        }
      }
      if (firstAvailable) selectBagCard(firstAvailable);

      if (cards.length > 1) {
        initBagCarousel();
      }
    }

    /* ── Free-bag Embla carousel (>3 products) ── */
    function initBagCarousel() {
      if (bagEmbla) { bagEmbla.destroy(); bagEmbla = null; }
      if (typeof EmblaCarousel === 'undefined' || !elements.freeBagViewport) {
        if (elements.freeBagViewport) {
          elements.freeBagViewport.style.overflowX = 'auto';
          elements.freeBagViewport.style.webkitOverflowScrolling = 'touch';
        }
        return;
      }

      elements.freeBagWrap.classList.add('has-carousel');

      bagEmbla = EmblaCarousel(elements.freeBagViewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      bagEmbla.on('select', function () { updateBagDots(); updateBagArrows(); });
      bagEmbla.on('reinit', function () { buildBagDots(); updateBagArrows(); });

      buildBagDots();
      updateBagArrows();

      if (elements.freeBagPrev) {
        elements.freeBagPrev.hidden = false;
        elements.freeBagPrev.addEventListener('click', function () { if (bagEmbla) bagEmbla.scrollPrev(); });
      }
      if (elements.freeBagNext) {
        elements.freeBagNext.hidden = false;
        elements.freeBagNext.addEventListener('click', function () { if (bagEmbla) bagEmbla.scrollNext(); });
      }
    }

    function buildBagDots() {
      if (!bagEmbla || !elements.freeBagDots) return;
      var snaps = bagEmbla.scrollSnapList();
      elements.freeBagDots.innerHTML = '';
      bagDotNodes = [];
      snaps.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'hc-easter-game__free-bag-dot';
        dot.setAttribute('aria-label', 'Go to group ' + (i + 1));
        dot.addEventListener('click', function () { bagEmbla.scrollTo(i); });
        elements.freeBagDots.appendChild(dot);
        bagDotNodes.push(dot);
      });
      updateBagDots();
    }

    function updateBagDots() {
      if (!bagEmbla || !bagDotNodes.length) return;
      var selected = bagEmbla.selectedScrollSnap();
      bagDotNodes.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === selected);
      });
    }

    function updateBagArrows() {
      if (!bagEmbla) return;
      if (elements.freeBagPrev) elements.freeBagPrev.disabled = !bagEmbla.canScrollPrev();
      if (elements.freeBagNext) elements.freeBagNext.disabled = !bagEmbla.canScrollNext();
    }

    function revealTurn(clickedEgg) {
      if (state.locked) return;
      if (clickedEgg.classList.contains('is-cracked')) return;
      state.locked = true;

      var wonPrize = clonePrize(state.turnPrizes[state.turn]);

      clickedEgg.classList.add('is-cracked', 'is-locked');

      showCelebration(clickedEgg, wonPrize, function () {
        setEggPrize(clickedEgg, wonPrize, true);
        clickedEgg.classList.add('is-revealed', 'is-picked');
        var eggImg = clickedEgg.querySelector('.hc-easter-game__egg-img');
        var eggIdx = Number(clickedEgg.getAttribute('data-egg-index'));
        var crackedUrl = getEggImage(eggIdx, 'cracked');
        if (eggImg && crackedUrl) eggImg.src = crackedUrl;
        if (wonPrize.key === 'free_bag') clickedEgg.classList.add('is-free-bag');

        state.wins.push({ turn: state.turn + 1, prize: wonPrize });
        updateVoucherBar();

        if (wonPrize.needsBag) {
          state.freeBagWon = true;
          hydrateFreeBags();
          elements.freeBagWrap.hidden = false;
        }

        state.turn += 1;
        if (elements.barTurn) elements.barTurn.textContent = 'Turn ' + Math.min(state.turn + 1, state.turnsTotal) + '/3';
        updateTurnBoxes();

        if (state.turn >= state.turnsTotal) {
          finishGame();
        } else {
          state.locked = false;
        }
      });
    }

    function showCelebration(egg, prize, onClose) {
      var overlay = root.querySelector('[data-hc-eg-celebration]');
      var cssEgg;
      var img;
      var fire;
      var base;
      if (!overlay) { onClose(); return; }

      var celebEgg = overlay.querySelector('.hc-easter-game__celebration-egg');
      var freshEgg = celebEgg.cloneNode(true);
      celebEgg.parentNode.replaceChild(freshEgg, celebEgg);

      var icon = freshEgg.querySelector('[data-hc-eg-celebration-icon]');
      var result = freshEgg.querySelector('[data-hc-eg-celebration-result]');
      if (!icon || !result) { onClose(); return; }

      var eggIdx = Number(egg.getAttribute('data-egg-index'));
      var intactUrl = getEggImage(eggIdx, 'intact');
      var crackedUrl = getEggImage(eggIdx, 'cracked');

      if (intactUrl) {
        icon.innerHTML = '<img src="' + intactUrl + '" alt="" style="width:100%;height:100%;object-fit:contain;">';
      } else {
        cssEgg = egg.querySelector('.hc-easter-game__egg-icon');
        if (cssEgg) icon.style.background = window.getComputedStyle(cssEgg).background;
      }

      result.textContent = '';
      result.className = 'hc-easter-game__celebration-result';
      overlay.hidden = false;

      window.setTimeout(function () {
        if (crackedUrl) {
          img = icon.querySelector('img');
          if (img) {
            img.src = crackedUrl;
            icon.style.animation = 'none';
          }
        }
        icon.classList.add('is-cracked-phase');
      }, 700);

      window.setTimeout(function () {
        result.textContent = prize.label;
        if (prize.score >= 450 || prize.needsBag) {
          result.classList.add('hc-easter-game__celebration-result--big');
        }
        result.style.animation = 'hcCelebrationReveal 0.5s ease forwards';
        result.style.opacity = '0';
      }, 900);

      window.setTimeout(function () {
        fire = typeof window.confetti === 'function' ? window.confetti : null;
        if (!fire) {
          console.warn('[Easter Game] window.confetti not available — canvas-confetti not loaded?');
          return;
        }
        base = { zIndex: 99999 };
        if (prize.needsBag) {
          fire(Object.assign({}, base, { particleCount: 200, spread: 90, origin: { y: 0.45 }, colors: ['#A9894C', '#D4AF37', '#FFD700', '#F5D86E'] }));
          window.setTimeout(function () {
            fire(Object.assign({}, base, { particleCount: 80, spread: 120, origin: { y: 0.5 }, colors: ['#A9894C', '#D4AF37', '#FFD700'] }));
          }, 300);
        } else if (prize.score >= 450) {
          fire(Object.assign({}, base, { particleCount: 120, spread: 80, origin: { y: 0.45 } }));
        } else if (prize.score >= 200) {
          fire(Object.assign({}, base, { particleCount: 40, spread: 60, origin: { y: 0.45 } }));
        }
      }, 950);

      window.setTimeout(function () {
        overlay.hidden = true;
        onClose();
      }, 2500);
    }

    function finishGame() {
      var eggs = Array.prototype.slice.call(elements.grid.querySelectorAll('.hc-easter-game__egg'));
      var decoys = randomDecoyPrizes(9);

      eggs.forEach(function (egg, idx) {
        if (egg.classList.contains('is-cracked')) return;
        setEggPrize(egg, decoys[idx], false);
        egg.classList.add('is-revealed', 'is-locked');
      });

      updateTurnBoxes();

      var best = findBestPrize();
      if (best && best.code) {
        state.bestCode = best.code;
      }
    }

    function copyText(text, triggerEl) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(function () {
        if (!triggerEl) return;
        var original = triggerEl.textContent;
        triggerEl.textContent = 'Copied!';
        window.setTimeout(function () {
          triggerEl.textContent = original;
        }, 1000);
      }).catch(function () {
        if (!triggerEl) return;
        triggerEl.textContent = 'Copy failed';
      });
    }

    function claimFreeBag() {
      if (!state.selectedBagVariantId) return;
      elements.claimBtn.disabled = true;
      elements.claimBtn.textContent = 'Adding to cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(state.selectedBagVariantId), quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (data && data.status === 422) {
          throw new Error(data.description || 'This bag may have sold out. Please select another.');
        }
        elements.claimBtn.textContent = 'Redirecting to checkout...';
        window.location.href = '/discount/' + encodeURIComponent(config.codeFree) + '?redirect=/checkout';
      })
      .catch(function (err) {
        elements.claimBtn.disabled = false;
        elements.claimBtn.textContent = 'Try Again';
        elements.claimBtn.setAttribute('title', err.message || 'Something went wrong. Please try again.');
      });
    }

    function spawnReaction() {}

    function addChatMessage(payload) {
      if (!elements.chatList) return;
      var avatarColors = ['#F8B4C8', '#A8D8EA', '#B5EAD7', '#FFEAA7', '#D4A5E5', '#FFD3B6'];
      var item = document.createElement('article');
      item.className = 'hc-easter-game__chat-item' + (payload.isPurchase ? ' hc-easter-game__chat-item--purchase' : '');
      item.innerHTML =
        '<span class="hc-easter-game__chat-avatar" style="background:' + randomOf(avatarColors) + '">' + payload.name.charAt(0) + '</span>' +
        '<div class="hc-easter-game__chat-body">' +
          '<div class="hc-easter-game__chat-name">' + payload.name + '</div>' +
          '<div class="hc-easter-game__chat-text">' + payload.text + '</div>' +
        '</div>';
      elements.chatList.appendChild(item);

      while (elements.chatList.children.length > 7) {
        elements.chatList.removeChild(elements.chatList.firstChild);
      }
    }

    function updateViewers() {
      if (!elements.viewers) return;
      state.viewers += randInt(-5, 8);
      if (state.viewers < 1000) state.viewers = 1034;
      elements.viewers.textContent = state.viewers.toLocaleString() + ' watching';
    }

    function startFakeChat() {
      var names = ['Jasmine T.', 'Keisha M.', 'Aaliyah J.', 'Tamika R.', 'Amara W.', 'Zuri K.', 'Nia D.', 'Imani P.', 'Sade H.', 'Destiny C.', 'Layla B.', 'Serena G.', 'Brianna F.', 'Naomi R.'];
      var msgs = [
        'just cracked 25% OFF 😍',
        'who else got the 50%??',
        'this game is so addicting omg',
        'just copied my code lessgoo',
        'these deals are REAL yall',
        'going for turn 3 wish me luck',
        'the bags are gorgeous frfr',
        'someone just got a FREE BAG 🎉'
      ];
      var purchases = [
        'just checked out the Kadia Crossbody with 45% off!',
        'claimed the Siyanda Tote — best deal ever!',
        'used my EASTER25 code and saved big',
        'got 2 bags with the 50% deal literally crying',
        'just used EASTER70 successfully 💎'
      ];

      var firstBurst = shuffle(msgs).slice(0, 3);
      firstBurst.forEach(function (text, i) {
        window.setTimeout(function () {
          addChatMessage({ name: randomOf(names), text: text });
        }, i * 600);
      });

      function tick() {
        var isPurchase = Math.random() < 0.24;
        addChatMessage({
          name: randomOf(names),
          text: isPurchase ? randomOf(purchases) : randomOf(msgs),
          isPurchase: isPurchase
        });

        if (Math.random() < 0.35) {
          spawnReaction();
        }

        updateViewers();
        state.chatTimer = window.setTimeout(tick, randInt(2000, 4000));
      }

      state.chatTimer = window.setTimeout(tick, 2200);
    }

    elements.grid.addEventListener('click', function (event) {
      var egg = event.target.closest('.hc-easter-game__egg');
      if (!egg) return;
      revealTurn(egg);
    });

    if (elements.popupCopy) {
      elements.popupCopy.addEventListener('click', function () {
        copyText(elements.popupCode.textContent || '', elements.popupCopy);
      });
    }

    elements.voucherList.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-copy-code]');
      if (!btn) return;
      var code = btn.getAttribute('data-copy-code') || '';
      if (!code) return;

      var allBtns = Array.prototype.slice.call(elements.voucherList.querySelectorAll('[data-copy-code]'));
      allBtns.forEach(function (b) {
        b.disabled = false;
        b.textContent = config.textVoucherClaim;
        b.classList.remove('is-applied');
      });

      btn.disabled = true;
      btn.textContent = 'Applying...';
      copyText(code, null);

      var pct = 0;
      state.wins.forEach(function (w) {
        if (w.prize.code === code) {
          pct = parseInt(w.prize.label, 10) || 0;
        }
      });

      applyDiscountAndScroll(code);
      window.setTimeout(function () {
        btn.textContent = config.textVoucherApplied;
        btn.classList.add('is-applied');
        if (productsCache.length && pct > 0) {
          showCollectionProducts(code, pct);
        }
      }, 1500);
    });

    elements.claimBtn.addEventListener('click', claimFreeBag);

    

    state.turnPrizes = computeTurnPrizes();
    fetchCollectionProducts();
    renderGrid();
    updateVoucherBar();
  });
})();
